import React from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
} from 'react-bootstrap';
import { useEffect } from 'react';
import { useState } from 'react';
import ProfilesRequestService from '../../services/profiles-request';
import { Trans } from 'react-i18next';
import Pagination from 'react-js-pagination';
import { AssignmentIndOutlined, Edit, Add } from '@material-ui/icons';
import BootstrapTable from 'react-bootstrap-table-next';
import Can from '../../components/Can';
import history from '../history';
import Loading from 'components/Loading';
import { DebounceInput } from 'react-debounce-input'
import { Link } from 'react-router-dom';

export default function () {
  const defaultFilters = { 
    per_page: 10, 
    page: 1,
    __search: "",
    fields: 'id,name'
  };

  const [profiles, setProfiles] = useState([]);
  const [pagination, setPagination] = useState({});
  const [filters, setFilters] = useState(defaultFilters);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getProfiles()
  }, [filters]);

  const getProfiles = () => {
    let filters_aux = {
      ...filters,
    };

    setIsLoading(true);
    ProfilesRequestService
      .getAll({ params: { ...filters_aux } })
      .then(({ data: response }) => {
        let { data, pagination } = response;
        setProfiles(data);
        setPagination(pagination);
      }).finally(() => setIsLoading(false));
  }

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  const handlePageChange = (page) => handleFilterChange({ page });

  const Data = [];

  const renderData = () => {
    profiles.map((item, k) => {
      Data.push({
        id: item.id,
        name: item.name,
        edit: (
          <Can do="profile.edit" on="App">
            <Link to={`/profiles/show/${item.id}`}>
              <Button className="btn-add">
                <Edit />
              </Button>
            </Link>
          </Can>
        ),
      });
    });
  };

  const columns = [
    {
      dataField: 'id',
      text: '#',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'name',
      text: 'Nome',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      dataField: 'edit',
      text: 'Editar',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center',
      },
    },
  ];

  const filterList = [
    {
      title: 'Pesquisa',
      width: 4,
      key: '__search',
      as: 'input',
    },
  ];

  const minWidth = 500;
  const isMobile = window.innerWidth <= minWidth;

  renderData();
  return (
    <>
      <Container>
        <Row className="mt-4">
          <AssignmentIndOutlined className="icon-title" />
          <h5 className="title-dashboard">Perfis</h5>
        </Row>
        <Row>
          <Card.Body
            className={
              'card-dashboard shadow bg-white rounded m-2 col-12' +
              (isMobile ? '' : ' p-5')
            }
          >
            <Can do="profile.create" on="App">
              <Row className="col-12 mb-3">
                <Button className="btn-add" onClick={() => {
                  history.push('/profiles/show')
                }}>
                  <Add /> Criar perfil
                </Button>
              </Row>
            </Can>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Registros por página:</Form.Label>
                  <Form.Control
                    as="select"
                    value={filters.per_page}
                    onChange={(e) =>
                      handleFilterChange({ per_page: e.target.value })
                    }
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Pesquisar</Form.Label>
                  <DebounceInput
                    element={Form.Control}
                    debounceTimeout={500}
                    value={filters.__search}
                    onChange={({ target }) => {
                      handleFilterChange({ __search: target.value, page: 1 })
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            {isLoading ? (<Loading page/>) : (
              <Row className="mt-4">
                <Col>
                  <BootstrapTable
                    style={{ width: '100px' }}
                    id="table"
                    className="font-10"
                    keyField="id"
                    data={Data}
                    columns={columns}
                    bordered
                    hover
                    condensed
                  />
                  <Row>
                    <Col xs="12" md="6">
                      <Trans i18nKey="label:interpolateShowingRecords">
                        Showing {{ from: pagination.from || '0' }} to{' '}
                        {{ to: pagination.to || '0' }} from{' '}
                        {{ total: pagination.total }} records
                      </Trans>
                    </Col>
                    <Col xs="12" md="6" className="d-flex justify-content-end">
                      <Pagination
                        activePage={pagination.current_page}
                        itemsCountPerPage={parseInt(pagination.per_page)}
                        totalItemsCount={pagination.total ?? 0}
                        pageRangeDisplayed={isMobile ? 3 : 5}
                        onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                        prevPageText="‹"
                        nextPageText="›"
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Card.Body>
        </Row>
      </Container>
    </>
  );
};
